import { INFLATION_RATE, RETURN_RATE } from "@/constants/data";

export function calculateRetirement(selectedGoals, years) {
  const currentCorpus = selectedGoals.reduce((sum, g) => sum + g.value, 0);
  const futureCorpus = currentCorpus * Math.pow(1 + INFLATION_RATE, years);
  const lumpsumRequired = futureCorpus / Math.pow(1 + RETURN_RATE, years);

  const r = RETURN_RATE / 12;
  const n = years * 12;

  // Invested at the end of month
  // const sip = (futureCorpus * r) / (Math.pow(1 + r, n) - 1);
  // Invested at the start of month
  const sip =
  futureCorpus /
  ((((1 + r) ** n - 1) / r) * (1 + r));

  return {
    currentCorpus,
    futureCorpus,
    lumpsumRequired,
    sip: Math.round(sip),
    years,
    inflationRate: INFLATION_RATE,
    returnRate: RETURN_RATE,
  };
}
